"use client"

import { IconButton } from "@/components/ui/icon-button"
import { Text } from "@/components/ui/text"

interface QtyStepperProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
}

const stepClass = "size-9 text-heading-sm font-semibold text-fg-brand hover:bg-brand-subtle focus-visible:ring-inset focus-visible:ring-offset-0"

export const QtyStepper = ({ value, onChange, min = 1, max = 99 }: QtyStepperProps) => (
  <div className="border-line bg-surface border-field inline-flex items-center overflow-hidden rounded-full">
    <IconButton variant="ghost" aria-label="Disminuir" disabled={value <= min} onClick={() => onChange(value - 1)} className={stepClass} icon="−" />
    <Text as="span" variant="body" family="display" tone="default" className="min-w-9 text-center font-semibold">
      {value}
    </Text>
    <IconButton variant="ghost" aria-label="Aumentar" disabled={value >= max} onClick={() => onChange(value + 1)} className={stepClass} icon="+" />
  </div>
)
